module.exports = __webpack_public_path__ + "static/media/yellowButton.587a09a2.svg";